// extracted by mini-css-extract-plugin
module.exports = {"Risk":"Risk_Risk__t3ZgR"};